import React, { useState } from 'react';
import {useParams, useHistory} from "react-router-dom"
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { C } from '../styles/tokens';
import Content from "./Content"
import UploadAudio from '../components/UploadAudio';
import CreateAudioModal from '../components/content/CreateAudioModal';
import { useIntegration } from '../http-hooks/integration/useIntegration';
import { PageHeader } from '../components/ui/bootstrap';
import { addMixPanelEvent } from '../store/actions';
import { CREATE_AUDIO_USECASE_SELECTED } from '../constants/mixpanel-events';


function ContentVoiceOver(){
    const { org_id, id } = useParams();
    const history = useHistory()
    const dispatch = useDispatch();
    const [selectedAudio, setSelectedAudio] = useState(null);
    const [showUploadAudio, setShowUploadAudio] = useState();
    const [showCreateAudioModal, setShowCreateAudioModal] = useState(false);

    const { data: integration } = useIntegration({ org_id, integration_id: id });

    const canUploadAudio = integration?.gates?.can_upload_audio || false;
    const canCreateAudio = integration?.gates?.can_create_audio || false;

    const displayNotAllowMessage = () => {
        toast.error("You are not allowed to perform this operation");
    }

    const createAudioHandler = () => {
        if(canCreateAudio){
            setShowCreateAudioModal(true);
            return;
        }
        displayNotAllowMessage()
    }

    const handleUseCasePick = (useCase) => {
        setShowCreateAudioModal(false);
        dispatch(addMixPanelEvent({
            orgId: org_id, integrationId: id, body: {
                eventName: CREATE_AUDIO_USECASE_SELECTED,
                eventData: { useCase },
            },
        }));
        history.push(`/organisation/${org_id}/integration/${id}/content/new`);
    }

    const uploadAudioHandler = () => {
        if(canCreateAudio && canUploadAudio){
            setShowUploadAudio(true);
            setSelectedAudio(null);
            return
        }
        displayNotAllowMessage()
    }

    return(
        <React.Fragment>
            <PageHeader
                title="AI Voiceovers"
                subtitle="Create and manage your voiceover library"
                right={
                    <>
                        {/* Upload button — hidden for now */}
                        <button
                            onClick={createAudioHandler}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 6,
                                padding: '7px 14px', border: 'none', borderRadius: 8,
                                background: C.n900, color: C.w,
                                fontSize: 13, fontWeight: 600, cursor: 'pointer',
                            }}
                        >
                            + Create Audio
                        </button>
                    </>
                }
            />
            <UploadAudio
                orgId={org_id}
                integrationId={id}
                show={showUploadAudio}
                selectedAudio={selectedAudio}
                onSuccess={() => {

                    setSelectedAudio(null);
                    window.location.reload();

                }} 
                onHide={() => {

                    setShowUploadAudio(false);
                    setSelectedAudio(null)

                }}
            />

            <CreateAudioModal
                show={showCreateAudioModal}
                onClose={() => setShowCreateAudioModal(false)}
                onPick={handleUseCasePick}
            />

            <Content contentType="voice_over" setSelectedAudio={(val) => setSelectedAudio(val)} setShowUploadAudio={(val) => setShowUploadAudio(val)} />
        </React.Fragment>
    );
}

export default ContentVoiceOver;